module.exports = __webpack_public_path__ + "static/media/rs.50735c6f.mp3";